// extracted by css-extract-rspack-plugin
export default {"floatingButtonSpace":"FloatingContainer__floatingButtonSpace--nkasI"};